import { Box, Typography } from '@material-ui/core';
import EditableTime from './EditableTime';
import Versus from './Versus';

// The screen the stream sits on before it starts. The time is the operator's,
// set by double clicking it.
function WaitingSlide(props) {
    return (
        <Box
            height='100%'
            display='flex'
            flexDirection='column'
            alignItems='center'
            justifyContent='center'
            textAlign='center'
            p={6}
        >
            <Typography variant='h3'> {props.tournamentName} </Typography>
            {props.matchLabel && <Typography variant='h4' color='textSecondary'> {props.matchLabel} </Typography>}
            <Box mt={4} mb={2}>
                <Typography variant='h3' color='textSecondary'> {props.headline} </Typography>
            </Box>
            <Typography variant='h1' component='div'>
                <EditableTime value={props.time} onChange={props.onTimeChange} />
            </Typography>
            <Box mt={6}>
                <Versus variant='h4' contestant1={props.contestant1} contestant2={props.contestant2} />
            </Box>
        </Box>
    );
}

export default WaitingSlide;
